import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

import BaseTag from "@/components_v2/Tags/BaseTag";
import { SectionCompletionStatus } from "../constants";
import {
  getSectionCompletionCounts,
  getSectionCompletionStatus,
} from "../utils/sectionStatus";
import { SectionStatusTagProps } from "../types";

const STATUS_CONFIG = {
  [SectionCompletionStatus.NONE]: {
    iconColor: "var(--red-500)",
    backgroundColor: "var(--red-400-10)",
    borderColor: "var(--red-500)",
    color: "var(--red-600)",
  },
  [SectionCompletionStatus.PARTIAL]: {
    iconColor: "var(--orange-500)",
    backgroundColor: "var(--orange-500-10)",
    borderColor: "var(--orange-500)",
    color: "var(--orange-800)",
  },
  [SectionCompletionStatus.COMPLETE]: {
    iconColor: "var(--green-700)",
    backgroundColor: "var(--green-500-10)",
    borderColor: "var(--green-500)",
    color: "var(--green-800)",
  },
} as const;

const SectionStatusTag = ({ statistics }: SectionStatusTagProps) => {
  const counts = getSectionCompletionCounts(statistics);
  const status = getSectionCompletionStatus(counts);
  const config = STATUS_CONFIG[status];

  const StatusIcon =
    status === SectionCompletionStatus.COMPLETE
      ? CheckCircleOutlined
      : ExclamationCircleOutlined;

  return (
    <span className="flex-shrink-0">
      <BaseTag
        size="small"
        hasRoundCorners
        label={`${counts.answered}/${counts.total}`}
        icon={<StatusIcon style={{ color: config.iconColor }} />}
        style={{
          backgroundColor: config.backgroundColor,
          borderColor: config.borderColor,
          color: config.color,
        }}
      />
    </span>
  );
};

export default SectionStatusTag;
